// extracted by mini-css-extract-plugin
module.exports = {"parts-table__body":"parts-table_parts-table__body__MnQY8","parts_table_objects":"parts-table_parts_table_objects__aPQay"};